export default __webpack_public_path__ + "static/media/plus-square.18f859e8.svg";